<template>
	<div>
		<div class="data9">
			<div class="data9Left" :style="{
				paddingLeft:bj+'px'
			}">
				<div class="data9LeftTil">{{list.data.menuTitle}}</div>
				<div class="data9LeftBox">
					<div class="data9LeftFor" v-for="(item,index) in list.data.content" :key="index">
						<div class="data9LeftForImg">
							<img :src="item.cover" />
						</div>
						<div class="data9LeftForName">
							{{item.title}}
						</div>
						<div class="data9LeftForCen">
							<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="data9Right">
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.cover" :key="index">
							<img :src="item" v-if="list.data.type==1" :style="{
								height:list.data.height+'px'
							}" />
							<!-- <video :src="item" :autoplay="true" v-else muted loop :style="{
								height:list.data.height+'px'
							}"></video> -->
							<template v-else>
								<template v-if="headerShow">
									<video :src="item" :autoplay="true" muted loop :style="{
								height:list.data.height+'px'
							}" webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
								</template>
								<template v-else>
									<video :src="item"  muted loop :style="{
								height:list.data.height+'px'
							}" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
								</template>
							</template>
						</div>
					</div>
					<template v-if="!headerShow">
							<div class="swiper-hexin-prev"  :style="{
								left:`30px`,
								display:qhShow?activeIndex==0?'none':'block':'none'
							}" @click="prev()">
								<img src="@/assets/index/hxz.png" />
							</div>
							<div class="swiper-hexin-next" :style="{
								right:`30px`,
								display:qhShow?activeIndex==list.data.cover.length-1?'none':'block':'none'
							}" @click="next()">
								<img src="@/assets/index/hxy.png" />
							</div>
						</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				njgfList: [{
						img: require('@/assets/product/page3/yjscz.png'),
						name: '一键式操作',
						cen: '一键开关，打开即用免去各类繁琐设置'
					},
					{
						img: require('@/assets/product/page3/gjyx.png'),
						name: '高兼容性',
						cen: '可直连医院二氧化碳管路兼容主流品牌内镜主机'
					},
				],
				bj: '',
				qhShow:true,
				activeIndex: 0,
			}
		},
		mounted() {
			let t = this;
			this.getWidth();
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			let name = '.swiper-data2-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				allowTouchMove: this.list.data.cover.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.cover.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.cover.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.cover.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data9 {
		display: flex;
		padding-bottom: 150px;

		.data9Left {
			flex: 1;
			padding-left: 200px;

			.data9LeftTil {
				font-size: 45px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #000000;
				margin-bottom: 85px;
			}

			.data9LeftBox {
				padding-right: 20px;
				display: flex;
				// align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;

				.data9LeftFor {
					width: calc(49.9% - 20px);
					margin-bottom: 93px;

					.data9LeftForImg {
						margin-bottom: 35px;

						img {
							width: 70px;
							height: 70px;
						}
					}

					.data9LeftForName {
						margin-bottom: 35px;
						font-size: 26px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #000000;
						white-space: pre-line;
					}

					.data9LeftForCen {
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #000000;

						>div {
							white-space: pre-line;
						}
					}
				}
			}
		}

		.data9Right {
			width: 50vw;

			// background: #000000;
			img {
				width: 100%;
				height: 600px;
			}
		}
	}

	.swiper-data2-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
		.swiper-slide33 {
			width: 580px;
		}
	}

	.swiper-slide {
		position: relative;

		img {
			width: 50vw;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 50vw;
			height: 600px;
			object-fit: contain;
		}
	}

	@media screen and (max-width:1200px) {
		.data9 {
			flex-wrap: wrap;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
			width: 100% !important;

			.data9Left {
				min-width: 100% !important;
				padding-left: 0px !important;

				.data9LeftTil {
					font-size: 24px !important;
					margin-bottom: 20px !important;
				}

				.data9LeftBox {
					padding-right: 0px !important;

					.data9LeftFor {
						width: calc(49.9% - 20px);
						margin-bottom: 20px !important;

						.data9LeftForImg {
							margin-bottom: 20px !important;

							img {
								width: 35px !important;
								height: 35px !important;
							}
						}

						.data9LeftForName {
							margin-bottom: 20px !important;
							font-size: 18px !important;
						}

						.data9LeftForCen {
							font-size: 14px !important;
						}
					}
				}
			}

			.data9Right {
				width: 100% !important;

				// background: #000000;
				img {
					width: 100%;
					height: auto !important;
					object-fit: contain;
				}
			}
		}

		.swiper-slide {
			width: 100% !important;
			img {
				width: 100%;
				height: auto !important;
				object-fit: contain;
			}

			video {
				width: 100%;
				height: auto !important;
				object-fit: contain;
			}
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>